angular.module('aprima-core-ui').directive('apAuthorization', [ 'AuthorizationService', function (AuthorizationService) {
    'use strict';

    return {
        restrict: 'A',
        scope: {
            providerRequired: '@'
        },
        link: function (scope, element) {
            if(scope.providerRequired){
                if(!AuthorizationService.isUserProvider()){
                    // only calling $destroy here because this is using an isolate scope for this directive
                    // that can be safely destroyed when this element is removed
                    // don't do this if it's sharing an outer scope with some other element, or there will likely be issues
                    scope.$destroy();
                    element.remove();
                }
            }
        }
    };
}]);